import { FormGroup, Label, Col } from "reactstrap";
import { CardSelect } from "../../../../../globals/core/CardSelect/CardSelect";
import { searchRelatedAction } from "../../../../content/Content";
import styles from "./index.module.scss";

const RelatedItems = ({ related, handleRelatedChange }) => (
    <Col className="px-2">
        <FormGroup className="mt-3 mt-lg-0 templating-select select2-container">
            <Label className={styles.label}>Related Items</Label>
            <CardSelect
                placeholder="Search for Content Items"
                cards={related}
                setCards={handleRelatedChange}
                searchAction={searchRelatedAction}
                fromSessionPage={true}
            />
        </FormGroup>
    </Col>
);

export default RelatedItems;
